export const CampaignType = {
  allTypes: 'all',
  generalMessageCampaign: 'GENERAL_MESSAGE_CAMPAIGN',
  earningRulesCampaign: 'EARNING_CAMPAIGN',
  couponsCampaign: 'COUPON_CAMPAIGN',
  stampCampaign: 'STAMP_CAMPAIGN',
  ticketCampaign: 'TICKET_CAMPAIGN',
};

export const TICKET_CAMPAIGN_OTHER_INFORMATION_QUESTION_TYPE = {
  CUSTOMER_PROFILE_FIELD: 'CUSTOMER_PROFILE_FIELD',
  CUSTOMER_ADDITIONAL_DATA_FIELD: 'CUSTOMER_ADDITIONAL_DATA_FIELD',
  ADDITION_QUESTION: 'ADDITION_QUESTION',
};

export const CUSTOMER_FIELD_NAME_LABELS = {
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  GENDER: 'Gender',
  BIRTHDAY: 'Birthday',
  REFERRAL_CODE: 'Referral code',
};

export const COUPON_SET_MEDIUM = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  ONLIEN_OR_OFFLINE: 'ONLINE_OR_OFFLINE',
};
export const GIFTCARD_CONTACT_TYPE = {
  EMAIL: 'email',
  SMS: 'sms',
};

export const COUPON_SET_TYPES = {
  SYSTEM_GENERATED: 'SYSTEM_GENERATED',
  IMPORT_EXISTING_COUPON: 'IMPORT_EXISTING_COUPON',
};

export const DISPLAY_COUPON_SET_TYPES = {
  [COUPON_SET_TYPES.SYSTEM_GENERATED]: "Generated by CMS",
  [COUPON_SET_TYPES.IMPORT_EXISTING_COUPON]: "External",
}
export const COUPON_TYPES = {
  ALL_TYPES: 'all',
  NORMAL: 'NORMAL',
  TICKET: 'TICKET',
};

export const DISPLAY_COUPON_TYPES = {
  [COUPON_TYPES.NORMAL]: 'Coupon',
  [COUPON_TYPES.TICKET]: 'Ticket',
};
export const COUPON_REDEMPTION_METHOD = {
  MERCHANT_APP_SCAN_COUPON_QR_CODE: 'MERCHANT_APP_SCAN_COUPON_QR_CODE',
  USERS_SCAN_STORE_QR_CODE: 'USERS_SCAN_STORE_QR_CODE',
  USERS_COPY_THE_DISCOUNT_CODE: 'USERS_COPY_THE_DISCOUNT_CODE',
  INPUT_STORE_STAFF_CODE: 'INPUT_STORE_STAFF_CODE',
  POS_UPDATED_CODE: 'POS_UPDATED_CODE',
};

export const DISPLAY_COUPON_REDEMPTION_METHOD = {
  MERCHANT_APP_SCAN_COUPON_QR_CODE: 'Merchant to scan coupon QR code',
  USERS_SCAN_STORE_QR_CODE: 'Customer app to scan store QR code',
  USERS_COPY_THE_DISCOUNT_CODE: 'Users copy the discount code',
  INPUT_STORE_STAFF_CODE: 'Input store PIN code only',
  POS_UPDATED_CODE: 'Sales system updated(e.g.POS)',
};

export const COUPON_FORMATS = {
  COUPON_QR_CODE: 'COUPON_QR_CODE',
  COUPON_BAR_CODE: 'COUPON_BAR_CODE',
  TEXT: 'TEXT',
};

export const DISPLAY_COUPON_FORMATS = {
  COUPON_QR_CODE: 'QR code',
  COUPON_BAR_CODE: 'Barcode',
  TEXT: 'TEXT',
};

export const COUPON_CODE_TYPE = {
  GENERIC: 'GENERIC',
  UNIQUE: 'UNIQUE',
};

export const DISPLAY_COUPON_CODE_TYPE = {
  [COUPON_CODE_TYPE.GENERIC]: 'Generic',
  [COUPON_CODE_TYPE.UNIQUE]: 'Unique',
};

export const COUPON_MODES = {
  COMMON: 'COMMON',
  STORE_SPECIAL: 'STORE_SPECIAL',
};

export const COUPON_STORE_GROUP_BY_TYPE = {
  MALL: 'MALL',
  STORE_CATEGORY: 'STORE_CATEGORY',
  BRAND: 'BRAND',
};

export const StepStatus = {
  error: 'error',
  processing: 'processing',
  finished: 'finished',
  waiting: 'waiting',
};

export const LanguageConfig = {
  english: 'en',
  simplifiedChinese: 'zh-Hans',
  traditionalChinese: 'zh-Hant',
};

export const LanguageUpperConfig = {
  english: 'EN',
  simplifiedChinese: 'ZH_HANS',
  traditionalChinese: 'ZH_HANT',
};

export const EarningRuleType = {
  allTypes: 'all',
  generalPurchase: 'GENERAL_PURCHASE',
  memberReferral: 'MEMBER_REFERRAL',
  birthday: 'BIRTHDAY',
  qrCodeScanning: 'QR_CODE_SCANNING',
  gpsCheckIn: 'GPS_CHECK_IN',
  newMember: 'NEW_MEMBER',
  fillingForm: 'FILLING_FORM',
  levelUpgrade: 'LEVEL_UPGRADE',
};

export const EarningRuleTypeKey = {
  All: 'allTypes',
  GENERAL_PURCHASE: 'generalPurchase',
  MEMBER_REFERRAL: 'memberReferral',
  BIRTHDAY: 'birthday',
  QR_CODE_SCANNING: 'qrCodeScanning',
  GPS_CHECK_IN: 'gpsCheckIn',
  NEW_MEMBER: 'newMember',
  FILLING_FORM: 'fillingForm',
  LEVEL_UPGRADE: 'levelUpgrade',
};

export const LanguageTabTransLation = {
  english: 'English',
  simplifiedChinese: '简体',
  traditionalChinese: '繁体',
};

export const LanguageTransLation = {
  en: 'English',
  'zh-Hans': '简体',
  'zh-Hant': '繁体',
};

export const AmOrPm = {
  am: 'am',
  pm: 'pm',
};

export const SavingStatus = {
  onSaving: 'onSaving',
  onFinished: 'onFinished',
};

export const APIStatus = {
  success: 'success',
  calling: 'calling',
  failed: 'failed',
  none: 'none',
};

export const MessageChannel = {
  all: 'All Possible Channels (SMS)',
  allWhatsapp: 'All Possible Channels (Whatsapp)',
  allWechat: 'All Possible Channels (WeChat)',
  push: 'Push',
  email: 'Email',
  sms: 'SMS',
  whatsapp: 'Whatsapp',
  wechat: 'WeChat',
  web: 'Web',
  inbox: 'Inbox',
  pushAndInbox: "pushAndInbox",
};

export const MessagePushAndInboxSelector = {
  both: 'both',
  push: 'push',
  inbox: 'inbox',
};

export const DisplayMessagePushAndInboxSelector = {
  both: 'Both Push and Inbox',
  push: 'Push only',
  inbox: 'Inbox only',
};

export const MessageBackendChannel = {
  all: 'ALL_POSSIBLE_CHANNELS_SMS',
  allWhatsapp: 'ALL_POSSIBLE_CHANNELS_WHATSAPP',
  allWechat: 'ALL_POSSIBLE_CHANNELS_WECHAT',
  push: 'PUSH_NOTIFICATION',
  email: 'EMAIL',
  sms: 'SMS',
  whatsapp: 'WHATSAPP',
  wechat: 'WECHAT',
  web: 'WEB', // CMS do not have this choice
  inbox: 'INBOX',
};

export const MessageWhatsappTemplateType = {
  TEXT: 'Text',
  IMAGE: 'Image',
  DOCUMENT: 'Document',
  VIDEO: 'Video',
};

export const MessageDefaultSteps = ['Channel', 'Property', 'Preview & Send'];

export const MessageStepConfig = [
  {
    name: 'Channel',
    show: (channels, isSystemMessage) => true,
  },
  {
    name: 'Content for Push/Inbox',
    show: (channels, isSystemMessage) =>
      channels.includes(MessageChannel.all) ||
      channels.includes(MessageChannel.allWhatsapp) ||
      channels.includes(MessageChannel.allWechat) ||
      channels.includes(MessageChannel.push) ||
      channels.includes(MessageChannel.inbox),
  },
  {
    name: 'Content for email',
    show: (channels, isSystemMessage) =>
      channels.includes(MessageChannel.all) ||
      channels.includes(MessageChannel.allWhatsapp) ||
      channels.includes(MessageChannel.allWechat) ||
      channels.includes(MessageChannel.email),
  },
  {
    name: 'Content for SMS',
    show: (channels, isSystemMessage) =>
      channels.includes(MessageChannel.all) ||
      channels.includes(MessageChannel.sms),
  },
  {
    name: 'Content for Whatsapp',
    show: (channels, isSystemMessage) =>
      channels.includes(MessageChannel.allWhatsapp) ||
      channels.includes(MessageChannel.whatsapp),
  },
  {
    name: 'Content for WeChat',
    show: (channels, isSystemMessage) =>
      channels.includes(MessageChannel.allWechat) ||
      channels.includes(MessageChannel.wechat),
  },
  {
    name: 'Property',
    show: (channels, isSystemMessage) => !isSystemMessage,
  },
  {
    name: 'Preview & Send',
    show: (channels, isSystemMessage) => !isSystemMessage,
  },
  {
    name: 'Preview & Publish',
    show: (channels, isSystemMessage) => isSystemMessage,
  },
];

export const CheckStatus = {
  initOrNotChecked: -1,
  checkedWithFail: 0,
  checkedWithSuccess: 1,
};

export const SavedStatus = {
  init: -1,
  savedWithFail: 0,
  savedWithSuccess: 1,
};

export const EarningRuleRewardType = {
  coupons: 'COUPON',
  points: 'POINTS',
  stamps: 'STAMP',
};

export const DISPLAY_EARNING_RULE_REWARD_TYPE = {
  [EarningRuleRewardType.points]: "Points",
  [EarningRuleRewardType.coupons]: "Coupons",
  [EarningRuleRewardType.stamps]: "Stamps",
}

export const EarningRuleLinkedCampaign = {
  stampCampaign: 'STAMP_CAMPAIGN',
  earningCampaign: 'EARNING_CAMPAIGN',
};

export const EarningRuleDefinitionType = {
  allFields: 'ALLFIELD',
  mandatoryFields: 'MANDATORYFIELD',
  oneField: 'ONEFIELD',
};

export const CustomerStatus = {
  active: 'active',
  deactive: 'deactive',

  temporaryEarning: 'temporary_earning',
  temporary: 'temporary',
  prospect: 'prospect',

  deleteRequested: 'delete_requested',
  deleted: 'deleted',
  merged: 'merged',
};

export const StatusTag = {
  active: 'Active',
  activeRequired: 'Active(Acquired)',

  activated: 'Activated',
  deactivated: 'Deactivated',

  deactive: 'Deactive',
  inactive: 'Inactive',

  temporaryEarning: 'Temp (can earn)',
  temporary: 'Temp (cannot earn)',
  prospect: 'Prospect',

  deleteRequested: 'RequestedToDel',
  deleted: 'Deleted',
  merged: 'Merged',
};

export const PublishTagType = {
  published: 'Published',
  unPublished: 'Unpublished',
  expired: 'Expired',
  draft: 'Draft',
  pendingForApproval: 'PendingForApproval',
};

export const DownloadTag = {
  completed: 'Exported',
  cancelled: 'Canceled',
  downloading: 'Exporting',
  importing: 'Importing',
  importCompleted: 'Imported',
  error: 'Error',
  generating: 'Generating',
  generated: 'Generated',
  pendingForImport: 'Pending',
  pendingForExport: 'Pending',
  pendingForGenerate: 'Pending',
};

export const MessageTag = {
  scheduled: 'Scheduled',
  draft: 'Draft',
  pendingForApproval: 'PendingForApproval',
  saved: 'Saved',
  sent: 'Sent',
  sending: 'Sending',
  error: 'Failed',
};

export const ConditionTag = {
  EQUAL_OR_LESS_THAN: 'Equal or less than',
  EQUAL_TO: 'Equal to',
  NOT_EQUAL_TO: 'Not equal to',
  IS_EMPTY: 'Is empty',
  IS_NOT_EMPTY: 'Is not empty',
  BETWEEN: 'Between',
  LESS_THAN: 'Less than',
  GREATER_THAN: 'Greater than',
  IN: 'In',
  CONTAINS_TEXT: 'Contains text',
  DOES_NOT_CONTAIN_TEXT: 'Does not contain text',
};

export const DaysTag = {
  '1_DAY': '1 day',
  '7_DAYS': '7 days',
  '1_MONTH': '1 month',
  '3_MONTHS': '3 months',
  '6_MONTHS': '6 months',
  '1_YEAR': '1 year',
};

const domain =
  process.env.REACT_APP_IMAGE || 'https://nginx.aillia.hkdev.motherapp.com';

export const ImageDomain = `${domain}/media/`;

export const StaticImageDomain = `${domain}/static/`;

export const webAppDomain =
  process.env.REACT_APP_WEBAPP_DOMAIN ||
  'https://webapp.aillia.hkdev.motherapp.com';

// TODO: webapp domain
export const CampaignDetailUrl = `${webAppDomain}/campaign/`;

const openInAppHost =
  process.env.REACT_APP_OPEN_IN_APP_HOST || 'download.aillia.motherapp.cn';

export const noWebapp = process.env.REACT_APP_NO_WEBAPP === 'true';
export const noShopify = process.env.REACT_APP_NO_SHOPIFY === 'true';
export const onlyHaveWebapp = process.env.REACT_APP_ONLY_HAVE_WEBSITE === 'true'
export const weekStartSunday = process.env.REACT_APP_WEEK_START_SUNDAY === 'true'
export const hideLevelDiscount = process.env.HIDE_LEVEL_DISCOUNT === 'true';
export const showCampaignPublishChannelSelector =
  process.env.REACT_APP_SHOW_CAMPAIGN_PUBLISH_CHANNEL_SELECTOR === 'true';

export const AppCampaignDetailUrl = `https://${openInAppHost}/?page=campaignDetail&id=`;

export const GenderOptions = [
  { pk: 'MALE', name: 'Male', value: 'MALE' },
  { pk: 'FEMALE', name: 'Female', value: 'FEMALE' },
  { pk: 'NOT_DISCLOSED', name: 'Prefer not to say', value: 'NOT_DISCLOSED' },
];

export const MonthOptions = [
  { pk: '1', name: 'January', value: '1' },
  { pk: '2', name: 'February', value: '2' },
  { pk: '3', name: 'March', value: '3' },
  { pk: '4', name: 'April', value: '4' },
  { pk: '5', name: 'May', value: '5' },
  { pk: '6', name: 'June', value: '6' },
  { pk: '7', name: 'July', value: '7' },
  { pk: '8', name: 'August', value: '8' },
  { pk: '9', name: 'September', value: '9' },
  { pk: '10', name: 'October', value: '10' },
  { pk: '11', name: 'November', value: '11' },
  { pk: '12', name: 'December', value: '12' },
];

export const CountryCodeOptions = [
  { pk: 852, name: '+852', value: 852 },
  { pk: 853, name: '+853', value: 853 },
  { pk: 86, name: '+86', value: 86 },
];

export const BANNER_CONTENT_TYPE = {
  ALL_TYPE: 'all',
  CAMPAIGN: 'CAMPAIGN',
  // PRODUCT: 'PRODUCT',
};

export const POINT_RECORD_TYPES = [
  { key: 'TYPE_POINT_ADD', name: 'Add Points' },
  { key: 'TYPE_POINT_REMOVE', name: 'Remove Points' },
];

export const COUPON_TEMPLATE_TYPE = {
  storeCode: 'STORE_CODE',
  couponCode: 'COUPON_CODE',
  couponQRCode: 'COUPON_QR_CODE',
  couponCodeImage: 'COUPON_CODE_IMAGE',
};

export const COUPON_TEMPLATE_TYPE_NAME = {
  STORE_CODE: 'Store code',
  COUPON_CODE: 'Coupon code',
  COUPON_QR_CODE: 'Coupon QR code',
  COUPON_CODE_IMAGE: 'Coupon code image',
};

export const DELETE_RELATED_SECTIONS = {
  CUSTOMER: [
    'AppInstallation',
    'CampaignParticipationRecord',
    'Coupon',
    'CouponTransaction',
    'PointTransaction',
    'Transaction',
  ],
  SEGMENT: ['Campaign'],
  CUSTOMER_GROUP: ['Campaign', 'ParticipationCustomer'],
  CAMPAIGN: [
    'Message',
    'CampaignParticipationRecord',
    'CouponTransaction',
    'PointsTransaction',
    'Segment Campaign Characteristic',
    'Banner',
  ],
  CAMPAIGN_CATEGORY: ['Campaign'],
  MESSAGE: ['InboxMessage'],
  EARNING_RULE: ['Campaign'],
  COUPON_TEMPLATE: ['Campaign', 'Coupon', 'EarningRule'],
  TICKET_SET: ['Campaign', 'Ticket', 'EarningRule'],
  COUPON: ['CouponTransaction'],
  TICKET: ['TicketTransaction'],
  BRAND: ['Campaign', 'CouponTemplate', 'Store'],
  STORE: ['CampaignParticipationRecord', 'Coupon', 'Transaction'],
  STORE_CATEGORY: ['StoreSubcategory'],
  TRANSACTION: [
    'CampaignParticipationRecord',
    'PurchasedItem',
    'Coupon transaction',
    'Point transaction',
  ],
  POINT_RECORD: [],
  COUPON_RECORD: [],
  ADMIN_GROUP: ['ParticipationAdmin'],
  ADMIN: ['CouponTransaction', 'ImportJob', 'ExportJob'],
  BANNER: [],
  WEBVIEW: [],
  STAMP_RECORD: [],
};

export const EMAIL_REG =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const SESSION_KEYS = {
  ADMIN_GROUP_SESSION_KEY: 'tempAdminGroup',
  ADMIN_SESSION_KEY: 'tempAdmin',
  MALL_SESSION_KEY: 'tempMall',
  STORE_SESSION_KEY: 'tempStore',
  TRANSACTION_SESSION_KEY: 'tempTransaction',
  LANGUAGE_SESSION_KEY: 'language',
  LANGUAGE_DATA_SESSION_KEY: 'languages',
  GIFTCARD_SESSION_KEY: 'giftCard',
  GIFTCARD_DATA_SESSION_KEY: 'giftCards',
  GIFTCARD_RECORD_SESSION_KEY: 'giftCardRecord',
  GIFTCARD_RECORD_DATA_SESSION_KEY: 'giftCardRecords',
  GIFTCARD_VIRTUAL_CONFIG_SESSION_KEY: 'virtualGiftCardVariant',
  GIFTCARD_VIRTUAL_CONFIG_DATA_SESSION_KEY: 'virtualGiftCardVariants',
  LEVEL_SESSION_KEY: 'level',
  LEVEL_DATA_SESSION_KEY: 'levels',
  CREATE_LEVEL_SESSION_KEY: 'createLevel',
  CREATE_LEVEL_END_SESSION_KEY: 'createLevelStepEnd',
  CREATE_LEVEL_ORIGIN_DATA_SESSION_KEY: 'createLevelOriginalData',
  LEVEL_DISCOUNT_SESSION_KEY: 'levelDiscount',
  LEVEL_DISCOUNT_DATA_SESSION_KEY: 'levelDiscounts',
  CREATE_CAMPAIGN_SESSION_KEY: 'createCampaign',
  CREATE_CAMPAIGN_END_SESSION_KEY: 'createCampaignStepEnd',
  CREATE_CAMPAIGN_ORIGIN_DATA_SESSION_KEY: 'createCampaignOriginalData',
  CREATE_GENERAL_MESSAGE_CAMPAIGN_SESSION_KEY: 'createGeneralMessageCampaign',
  CREATE_GENERAL_MESSAGE_CAMPAIGN_END_SESSION_KEY: 'createGeneralMessageCampaignStepEnd',
  CREATE_GENERAL_MESSAGE_CAMPAIGN_ORIGIN_DATA_SESSION_KEY: 'createGeneralMessageCampaignOriginalData',
  CREATE_STAMP_CAMPAIGN_SESSION_KEY: 'createStampCampaign',
  CREATE_STAMP_CAMPAIGN_END_SESSION_KEY: 'createStampCampaignStepEnd',
  CREATE_STAMP_CAMPAIGN_ORIGIN_DATA_SESSION_KEY:
    'createStampCampaignOriginalData',
  CREATE_TICKET_CAMPAIGN_SESSION_KEY: 'createTicketCampaign',
  CREATE_TICKET_CAMPAIGN_END_SESSION_KEY: 'createTicketCampaignStepEnd',
  CREATE_TICKET_CAMPAIGN_ORIGIN_DATA_SESSION_KEY: 'createTicketCampaignOriginalData',
  CAMPAIGN_LIST_SESSION_KEY: 'campaigns',
  CAMPAIGN_CATEGORY_SESSION_KEY: 'campaignCategoryKey',
  CREATE_CAMPAIGN_CATEGORY_SUCCESS: 'createCampaignCategorySuccess',
  CREATE_CAMPAIGN_CATEGORY_FAILD: 'createCampaignCategoryFailed',
  CAMPAIGN_CATEGORY_ORDER_LAST: 'capaignCategoryLast',
  EARNING_RULES_SESSION_KEY: 'tempEarningRule',
  FILLING_FORM_SESSION_KEY: 'fillingForm',
  FILLING_FORM_DATA_SESSION_KEY: 'fillingForms',
  CREATE_MESSAGE_SESSION_KEY: 'createMessage',
  CREATE_MESSAGE_STEP_END_SESSION_KEY: 'createMessageStepEnd',
  CREATE_MESSAGE_ORIGINAL_DATA_SESSION_KEY: 'createMessageOriginalData',
  CREATE_COUPON_SESSION_KEY: 'createCoupon',
  CREATE_COUPON_END_SESSION_KEY: 'createCouponStepEnd',
  CREATE_COUPON_ORIGIN_DATA_SESSION_KEY: 'createCouponOriginalData',
  SINGLE_COUPON_LIST_SESSION_KEY: 'singleCoupons',
  CREATE_BRAND_SESSION_KEY: 'createBrand',
  CREATE_BRAND_STEP_END_SESSION_KEY: 'createBrandStepEnd',
  CREATE_BRAND_ORIGINAL_DATA_SESSION_KEY: 'createBrandOriginalData',
  CREATE_POINT_RECORD_STEP_END_SESSION_KEY: 'createPointRecordStepEnd',
  CREATE_POINT_RECORD_ORIGINAL_DATA_SESSION_KEY:
    'createPointRecordOriginalData',
  CREATE_PRODUCT_CATEGORY_SESSION_KEY: 'createProductCategory',
  CREATE_PRODUCT_CATEGORY_STEP_END_SESSION_KEY: 'createProductCategoryStepEnd',
  CREATE_PRODUCT_CATEGORY_ORIGINAL_DATA_SESSION_KEY:
    'createProductCategoryOriginalData',
  CREATE_PRODUCT_SUBCATEGORY_SESSION_KEY: 'createProductSubcategory',
  CREATE_PRODUCT_SUBCATEGORY_STEP_END_SESSION_KEY:
    'createProductSubcategoryStepEnd',
  CREATE_PRODUCT_SUBCATEGORY_ORIGINAL_DATA_SESSION_KEY:
    'createProductSubcategoryOriginalData',
};

export const TokenErrors = {
  Expiry: 'Signature has expired',
  DecodingError: 'Error decoding signature',
  RefreshTokenInvalid: 'Invalid refresh token',
  RefreshTokenExpired: 'Refresh token is expired',
  NoPermission: 'You do not have permission to perform this action',
};

export const STORE_LOADING_TYPE = {
  BRAND: 'brand',
  CAMPAIGN: 'campaignIn',
  COUPON: 'couponTemplateIn',
};

export const SIGN_UP_METHOD_DISPLAY = {
  MOBILE_PHONE_NUMBER: 'Mobile phone number',
  'GOOGLE-OAUTH2': 'Google OAuth2',
  FACEBOOK: 'Facebook',
  'APPLE-ID': 'Apple ID',
  EMAIL_ADDRESS: 'Email address',
  MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS:
    'Both Mobile phone number and email address',
};

export const SIGN_UP_METHOD = {
  MOBILE_PHONE_NUMBER: 'MOBILE_PHONE_NUMBER',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS:
    'MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS',
  'GOOGLE-OAUTH2': 'GOOGLE-OAUTH2',
  FACEBOOK: 'FACEBOOK',
  'APPLE-ID': 'APPLE-ID',
};

export const ADMINISTRATOR_TYPES = {
  CMS_ADMINISTRATOR: 'AILLIA_ADMIN',
  MERCHANT_APP_ACCOUNT: 'MERCHANT_APP_ACCOUNT',
};

export const ActionType = {
  save: 'save',
  publish: 'publish',
  forcePublish: 'forcePublish',
  none: 'none',
  saveAsDraft: 'saveAsDraft',
  update: 'update',
  submitForApproval: 'submitForApproval',
  pendingForApproval: 'pendingForApproval',
  withdraw: 'withdraw',
  approval: 'approval',
  unpublish: 'unpublish',
  tempForPulished: 'tempForPublished',
  withdrawFromPendding: 'withdrawPendingforApproval',
  withdrawFromApproval: 'withdrawApproval',
  reclaim: 'reclaim',
};

export const ApprovalStatus = {
  draft: 'DRAFT',
  pendingForApproval: 'PENDING_FOR_APPROVAL',
  published: 'PUBLISHED',
  scheduled: 'SCHEDULED',
  pending: 'PENDING',
};

export const WEEKDAY = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
};

export const POINTS_EXPIRY_DATE_VALUE = {
  ALL_TIME: 'ALL_TIME',
  IN_PERIOD: 'IN_PERIOD',
  DAYS_SINCE_ACQUIRE: 'DAYS_SINCE_ACQUIRE',
};

export const EXPIRY_TYPE_CONFIG = [
  {
    value: POINTS_EXPIRY_DATE_VALUE.ALL_TIME,
    label: 'All the time',
  },
  {
    value: POINTS_EXPIRY_DATE_VALUE.IN_PERIOD,
    label: 'In a period',
  },
  {
    value: POINTS_EXPIRY_DATE_VALUE.DAYS_SINCE_ACQUIRE,
    label: 'Number of days since acquiring',
  },
];

export const DISCOUNT_TYPE = {
  TRANSACTION: 'TRANSACTION',
  ITEM: 'ITEM',
  SHIPPING: 'SHIPPING',
  AILLIA_LEVEL_DISCOUNT: 'AILLIA_LEVEL_DISCOUNT',
  AILLIA_FREE_SHIPPING_DISCOUNT: 'AILLIA_FREE_SHIPPING_DISCOUNT',
  AILLIA_POINT_TO_CASH: 'AILLIA_POINT_TO_CASH',
};

export const ONLINE_STORE_DISCOUNT_TYPE = {
  ORDER: 'ORDER',
  PRODUCT: 'PRODUCT',
  DELIVERY: 'DELIVERY',
}

export const DISPLAY_ONLINE_STORE_DISCOUNT_TYPE = {
  ORDER: 'Order',
  PRODUCT: 'Product',
  DELIVERY: 'Delivery',
};

export const DISCOUNT_VALUE_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_VALUE: 'FIXED_VALUE',
};

export const REFUND_TYPE = {
  TOTAL_AMOUNT_OF_ORDER: 'TOTAL_AMOUNT_OF_ORDER',
  CUSTOM_QUANTITY: 'CUSTOM_QUANTITY',
};

export const CUSTOMER_DETAIL_COUPON_TYPE = {
  all: 'all',
  available: 'AVAILABLE',
  unavailable: 'UNAVAILABLE',
  used_or_expired: 'USED_OR_EXPIRED',
};

export const COUPON_VIRTUAL_REAL_TYPE = {
  normal: 'NORMAL',
  virtual: 'VIRTUAL',
  real: 'REAL',
};

export const CUSTOMER_DETAIL_TAB_NAME = {
  profile: 'Profile',
  exclusiveCampaign: 'Exclusive campaign',
  stampCampaign: 'Stamp campaign',
  earningRules: 'Earning rules',
  coupons: 'Coupons',
  tickets: 'Tickets',
  pointAndLevel: 'Points & Level',
  pointWithoutLevel: 'Points',
};

export const MESSAGE_TRACKING_TYPE_DISPLAY = {
  OPEN: 'Opened',
  NOT_OPEN: 'Did not opened',
  CLICK: 'Clicked on',
  NOT_CLICK: 'Did not clicked on',
};

export const MESSAGE_TRACKING_TYPE = {
  Opened: 'OPEN',
  'Did not opened': 'NOT_OPEN',
  'Clicked on': 'CLICK',
  'Did not clicked on': 'NOT_CLICK',
};

export const TRANSACTION_TYPE_DISPLAY = {
  NUMBER: 'Number',
  PERCENTAGE: 'Percentage',
};

export const TRANSACTION_TYPE = {
  Number: 'NUMBER',
  Percentage: 'PERCENTAGE',
};

export const PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE_DISPLAY = {
  ALL_ONLINE_STORE: 'All online stores',
  ALL_OFFLINE_STORE: 'All offline stores',
  SPECIFIC_STORE: 'Specific store(s)',
};

export const PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE = {
  'All online stores': 'ALL_ONLINE_STORE',
  'All offline stores': 'ALL_OFFLINE_STORE',
  'Specific store(s)': 'SPECIFIC_STORE',
};

export const POINTS_TO_EXPIRE_DATE_TYPE_DISPLAY = {
  DAY: 'day(s)',
  WEEK: 'week(s)',
};

export const POINTS_TO_EXPIRE_DATE_TYPE = {
  'day(s)': 'DAY',
  'week(s)': 'WEEK',
};

export const PERIOD_TYPE_DISPLAY = {
  ALL_THE_TIME: 'All the time',
  WITHIN: 'Within',
  EQUAL_TO: 'Equal to',
  BETWEEN: 'Between',
  LESS_THAN: 'Less than',
  GREATER_THAN: 'Greater than',
  AFTER: 'After',
  BEFORE: 'Before'
};

export const PERIOD_TYPE = {
  'All the time': 'ALL_THE_TIME',
  Within: 'WITHIN',
  'Equal to': 'EQUAL_TO',
  Between: 'BETWEEN',
  'Less than': 'LESS_THAN',
  'Greater than': 'GREATER_THAN',
  After: 'GREATER_THAN',
  Before: 'LESS_THAN',
};

export const PROGRESSION_POINTS_REACH_TARGET = {
  reachNextLevel: 'REACH_NEXT_LEVEL',
  retainCurrentLevel: 'RETAIN_CURRENT_LEVEL',
};

export const ADJUST_TYPES = {
  coupon: 'coupon',
  ticket: 'ticket',
  stamp: 'stamp',
}

export const POINT_TO_CASH_CONVERT_RATE = parseInt(
  process.env.REACT_APP_POINT_TO_CASH_CONVERT_RATE || 1000,
);

export const PROGRESSION_POINTS_REACH_TARGET_DISPLAY = {
  [PROGRESSION_POINTS_REACH_TARGET.reachNextLevel]: 'Reach the next level',
  [PROGRESSION_POINTS_REACH_TARGET.retainCurrentLevel]:
    'Retain in current level',
};

export const PROGRESSION_POINTS_REACH_TARGET_NUMBER_TYPE = {
  AMOUNT_IN_PERCENTAGE: 'AMOUNT_IN_PERCENTAGE',
  AMOUNT_IN_PP_VALUE: 'AMOUNT_IN_PP_VALUE',
};

export const AdditionalDataFieldType = {
  Text: 'TEXT',
  Number: 'NUMBER',
  Datetime: 'DATETIME',
  Toggle: 'TOGGLE',
  Checkbox: 'CHECKBOX',
  Dropdown: 'DROPDOWN',
  SingleChoices: 'SINGLE_CHOICES',
  MultiChoices: 'MULTI_CHOICES',
};

export const CouponVirtualRealType = {
  Normal: 'NORMAL',
  Virtual: 'VIRTUAL',
  Real: 'REAL',
};

export const LAST_MODIFIED_BY = {
  CMS_ADMIN: 'CMS_ADMIN',
  MERCHANT_ADMIN: 'MERCHANT_ADMIN',
  END_CUSTOMER: 'END_CUSTOMER',
  THIRD_PARTY_SYSTEM: 'THIRD_PARTY_SYSTEM',
  AILLIA_SYSTEM: 'AILLIA_SYSTEM',
  STORE_CODE: 'STORE_CODE',
};

export const DISPLAY_LAST_MODIFIED_BY = {
  [LAST_MODIFIED_BY.CMS_ADMIN]: 'CMS admin',
  [LAST_MODIFIED_BY.MERCHANT_ADMIN]: 'Merchant admin',
  [LAST_MODIFIED_BY.END_CUSTOMER]: 'Customer',
  [LAST_MODIFIED_BY.THIRD_PARTY_SYSTEM]: 'Third-party system',
  [LAST_MODIFIED_BY.AILLIA_SYSTEM]: 'Current system',
  [LAST_MODIFIED_BY.STORE_CODE]: 'Store code',
};

export const ADMIN_PERMISSION_TYPE = {
  CMS_ADMIN_PERMISSON: 'AILLIA_ADMIN',
  MERCHANT_ADMIN_PERMISSON: 'MERCHANT_APP_ACCOUNT',
};

export const DISPLAY_PERMISSION_TYPE = {
  [ADMIN_PERMISSION_TYPE.CMS_ADMIN_PERMISSON]:
    'Permissions for CMS admin users',
  [ADMIN_PERMISSION_TYPE.MERCHANT_ADMIN_PERMISSON]:
    'Permissions for merchant app users',
};

export const ADDITIONAL_FIELD_FORMAT_TYPE = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DATETIME: 'DATETIME',
  TOGGLE: 'TOGGLE',
  CHECKBOX: 'CHECKBOX',
  DROPDOWN: 'DROPDOWN',
  SINGLE_CHOICES: 'SINGLE_CHOICES',
  MULTI_CHOICES: 'MULTI_CHOICES',
};
export const CUSTOM_ADDITIONAL_FIELD_FORMAT_TYPE = {
  DATE_MONTH: 'DATE_MONTH',
}

export const DISPLAY_ADDITIONAL_FIELD_FORMAT_TYPE = {
  [ADDITIONAL_FIELD_FORMAT_TYPE.TEXT]: 'Text',
  [ADDITIONAL_FIELD_FORMAT_TYPE.NUMBER]: 'Number',
  [ADDITIONAL_FIELD_FORMAT_TYPE.DATETIME]: 'Datetime',
  [ADDITIONAL_FIELD_FORMAT_TYPE.TOGGLE]: 'Toggle',
  [ADDITIONAL_FIELD_FORMAT_TYPE.CHECKBOX]: 'Checkbox',
  [ADDITIONAL_FIELD_FORMAT_TYPE.DROPDOWN]: 'Dropdown',
  [ADDITIONAL_FIELD_FORMAT_TYPE.SINGLE_CHOICES]: 'Single choices',
  [ADDITIONAL_FIELD_FORMAT_TYPE.MULTI_CHOICES]: 'Multi choices',
};

export const CustomerSelectionBehavior = {
  NO_LIMIT: 'NO_LIMIT',
  SELECT_WHEN_ACQUIRE: 'SELECT_WHEN_ACQUIRE',
  SELECT_IN_WALLET: 'SELECT_IN_WALLET',
};


export const EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE = {
  perMember: "PER_MEMBER",
  perTransaction: "PER_TRANSACTION",
  stampCampaignMaxQtySlot: "STAMP_CAMPAIGN_MAX_QTY_SLOT"
}

export const DISPLAY_REWARD_GLOBAL_LIMIT_TARGET_TYPE = {
  [EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.perMember]: "Per member",
  [EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.perTransaction]: "Per transaction",
  [EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.stampCampaignMaxQtySlot]: "Stamp Campaign Max Quantity Slot",
}

export const EARNING_RULE_GLOBAL_LIMIT_PERIOD = {
  allTime: "ALL_TIME",
  perDay: "PER_DAY",
  perWeek: "PER_WEEK",
  perMonth: "PER_MONTH",
  perYear: "PER_YEAR",
}

export const DISPLAY_EARNING_RULE_GLOBAL_LIMIT_PERIOD = {
  [EARNING_RULE_GLOBAL_LIMIT_PERIOD.allTime]: "All time",
  [EARNING_RULE_GLOBAL_LIMIT_PERIOD.perDay]: "Per day",
  [EARNING_RULE_GLOBAL_LIMIT_PERIOD.perWeek]: "Per week",
  [EARNING_RULE_GLOBAL_LIMIT_PERIOD.perMonth]: "Per month",
  [EARNING_RULE_GLOBAL_LIMIT_PERIOD.perYear]: "Per year",
}

export const MEMBERSHIP_PERIOD_MODE = {
  fixed: "FIXED",
  dynamic: "DYNAMIC",
}

export const DISPLAY_MEMBERSHIP_PERIOD_MODE = {
  [MEMBERSHIP_PERIOD_MODE.fixed]: "Fixed",
  [MEMBERSHIP_PERIOD_MODE.dynamic]: "Dynamic",
}

export const LEVEL_CALCULATION_SOURCE = {
  spending: "SPENDING",
  pp: "PROGRESSION_POINTS",
}

export const DISPLAY_LEVEL_CALCULATION_SOURCE = {
  [LEVEL_CALCULATION_SOURCE.spending]: "Spending",
  [LEVEL_CALCULATION_SOURCE.pp]: "Progression points (PP)",
}

export const HANDLING_CALCULATION_SOURCE_AFTER_RENEWAL = {
  resetToZero: "RESET_TO_ZERO",
  unchanged: "UNCHANGED",
}

export const DISPLAY_HANDLING_CALCULATION_SOURCE_AFTER_RENEWAL = {
  [HANDLING_CALCULATION_SOURCE_AFTER_RENEWAL.resetToZero]: "Reset to 0",
  [HANDLING_CALCULATION_SOURCE_AFTER_RENEWAL.unchanged]: "Unchanged",
}

export const CARD_BACKGROUND_TYPE = {
  singleColor: "SINGLE_COLOR",
  image: "IMAGE",
}

export const DISPLAY_CARD_BACKGROUND_TYPE = {
  [CARD_BACKGROUND_TYPE.singleColor]: "Single color",
  [CARD_BACKGROUND_TYPE.image]: "Image",
}

export const LEVEL_RENEWAL_LOGIC = {
  retainCurrentLevel: "RRTAIN_CURRENT_LEVEL",
  checkRetainRequirement: "CHECK_RETAIN_REQUIREMENT",
  forceDowngrade: "SKIP_CHECKING_AND_FORCE_DOWNGRADE",
}

export const DISPLAY_LEVEL_RENEWAL_LOGIC = {
  [LEVEL_RENEWAL_LOGIC.retainCurrentLevel]: "Retain current level",
  [LEVEL_RENEWAL_LOGIC.checkRetainRequirement]: "Check retain requirement",
  [LEVEL_RENEWAL_LOGIC.forceDowngrade]: "Skip checking and force downgrade",
}

export const LEVEL_DOWNGRADE_LOGIC = {
  checkEntryRequirements: "CHECK_ENTRY_REQUIREMENTS",
  downgradeToSpecificLevel: "DOWNGRADE_TO_SPECIFIC_LEVLE",
}

export const DISPLAY_LEVEL_DOWNGRADE_LOGIC = {
  [LEVEL_DOWNGRADE_LOGIC.checkEntryRequirements]: "Check against condition 1 of entry requirements",
  [LEVEL_DOWNGRADE_LOGIC.downgradeToSpecificLevel]: "Downgrade to a specific level",
}

export const RECURRING_OFFSET_TYPE = {
  OFFSET_WEEKDAY: 'OFFSET_WEEKDAY',
  OFFSET_BY_RELATIVE_DAY: 'OFFSET_BY_RELATIVE_DAY',
  OFFSET_BY_RELATIVE_WEEK: 'OFFSET_BY_RELATIVE_WEEK',
  OFFSET_BY_RELATIVE_MONTH: 'OFFSET_BY_RELATIVE_MONTH',
  OFFSET_DAY_IN_MONTH: 'OFFSET_DAY_IN_MONTH',
}

export const RECURRING_ORDINAL_WEEKDAY_TYPE = {
  FIRST: 'First',
  SECOND: 'Second',
  THIRD: 'Third',
  FOURTH: 'Fourth',
  LAST: 'Last',
}

export const SIGN_UP_CHANNEL = {
  APP: "APP",
  WEBSITE: "WEBSITE",
  IMPORTED_BY_CSV: "IMPORTED_BY_CSV",
  ONLINE_STORE: "ONLINE_STORE",
  OFFLINE_STORE: "OFFLINE_STORE",
  WECHAT: "WECHAT",
  EVENT: "EVENT",
}

export const DISPLAY_SIGN_UP_CHANNEL = {
  APP: "App",
  WEBSITE: "Website",
  IMPORTED_BY_CSV: "Imported by csv",
  ONLINE_STORE: "Online Store",
  OFFLINE_STORE: "Offline Store",
  WECHAT: "WeChat",
  EVENT: "Event",
}

export const EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE = {
  brand: "brand",
  category: "category",
  subcategory: "subcategory",
  transactionAdditionalData: "transactionAdditionalData",
  purchasedItemAdditionalData: "purchasedItemAdditionalData",
  sku: "sku",
}

export const DISPLAY_EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE = {
  [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.brand]: "Brand",
  [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.category]: "Product categories",
  [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.subcategory]: "Subcategory",
  [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData]: "Additional data from transaction records",
  [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData]: "Additional data from purchased items",
  [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku]: "SKU",
}

export const SEGMENT_TYPE = {
  DYNAMIC: "DYNAMIC",
  STATIC: "STATIC",
}

export const DISPLAY_SEGMENT_TYPE = {
  [SEGMENT_TYPE.DYNAMIC]: "Dynamic",
  [SEGMENT_TYPE.STATIC]: "Static",
}

export const STATIC_SEGMENT_CUSTOMER_SOURCE = {
  CUSTOMER_NAME: "CUSTOMER_NAME",
  CONDITION: "CONDITION",
}

export const DISPLAY_STATIC_SEGMENT_CUSTOMER_SOURCE = {
  [STATIC_SEGMENT_CUSTOMER_SOURCE.CUSTOMER_NAME]: "By customer name",
  [STATIC_SEGMENT_CUSTOMER_SOURCE.CONDITION]: "By conditions",
}

export const TARGET_CUSTOMER_TYPE = {
  DYNAMIC_SEGMENT: "DYNAMIC_SEGMENT",
  STATIC_SEGMENT: "STATIC_SEGMENT",
  LEVEL: "LEVEL",
}

export const DISPLAY_TARGET_CUSTOMER_TYPE = {
  [TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT]: "Dynamic segment",
  [TARGET_CUSTOMER_TYPE.STATIC_SEGMENT]: "Static segment",
  [TARGET_CUSTOMER_TYPE.LEVEL]: "Level",
}

export const MESSAGE_TARGET_TYPE = {
  ...TARGET_CUSTOMER_TYPE
}

export const DISPLAY_MESSAGE_TARGET_TYPE = {
  ...DISPLAY_TARGET_CUSTOMER_TYPE
}

export const CUSTOMER_REFERRER_METHOD = {
  REFERRAL_CODE: "REFERRAL_CODE",
  PROMOTION_CODE: "PROMOTION_CODE",
}

export const DISPLAY_CUSTOMER_REFERRER_METHOD = {
  [CUSTOMER_REFERRER_METHOD.REFERRAL_CODE]: "Referral code (Membership ID)",
  [CUSTOMER_REFERRER_METHOD.PROMOTION_CODE]: "Promotion code",
}

export const ADMIN_ALERT_TYPE = {
  // deprecated
  TRANSACTION_REFUND: "TRANSACTION_REFUND",
  // deprecated
  TRANSACTION_REFUND_UNDO_FAIL: "TRANSACTION_REFUND_UNDO_FAIL",

  REFUNDED_INVOICE_ID_NOT_FOUND: "REFUNDED_INVOICE_ID_NOT_FOUND",
  REPEATED_REFUND: "REPEATED_REFUND",

  REWARD_LIMIT_RELEASED: "REWARD_LIMIT_RELEASED",
  TRANSACTION_VALUE_LIMIT_RELEASED: "TRANSACTION_VALUE_LIMIT_RELEASED",

  STAMP_CAMPAIGN_NO_LONGER_VALID: "STAMP_CAMPAIGN_NO_LONGER_VALID",
  RELATED_CAMPAIGN_CHANGED: "RELATED_CAMPAIGN_CHANGED",
}

export const DISPLAY_ADMIN_ALERT_TYPE = {
  // deprecated
  [ADMIN_ALERT_TYPE.TRANSACTION_REFUND]: "Transaction refund",
  // deprecated
  [ADMIN_ALERT_TYPE.TRANSACTION_REFUND_UNDO_FAIL]: "Transaction refund undo fail",

  [ADMIN_ALERT_TYPE.REFUNDED_INVOICE_ID_NOT_FOUND]: "Refunded invoice ID not found",
  [ADMIN_ALERT_TYPE.REPEATED_REFUND]: "Repeated refund / partial refund",

  [ADMIN_ALERT_TYPE.REWARD_LIMIT_RELEASED]: "Reward limit released",
  [ADMIN_ALERT_TYPE.TRANSACTION_VALUE_LIMIT_RELEASED]: "Transaction limit released",

  [ADMIN_ALERT_TYPE.STAMP_CAMPAIGN_NO_LONGER_VALID]: "Stamp campaign(s) no longer valid",
  [ADMIN_ALERT_TYPE.RELATED_CAMPAIGN_CHANGED]: "Related campaign(s) changed",
}

export const ALERT_STATUS = {
  INITIAL: "INITIAL",
  COMPLETED: "COMPLETED",
}

export const EarningRuleGlobalLimitReward = {
  POINTS: 'POINTS',
  PROGRESSION_POINTS: 'PROGRESSION_POINTS',
  COUPONS: 'COUPONS',
  STAMPS: 'STAMPS',
};

export const EarningRuleGlobalLimitPeriod = {
  ALL_TIME: 'ALL_TIME',
  PER_DAY: 'PER_DAY',
  PER_WEEK: 'PER_WEEK',
  PER_MONTH: 'PER_MONTH',
  PER_YEAR: 'PER_YEAR',
};

export const POINT_RECORD_TYPE = {
  TYPE_ADD: 'Add point',
  TYPE_REMOVE: 'Remove point',
};

export const recordListShowPhoneNumber = process.env.REACT_APP_RECORD_LIST_SHOW_PHONE_NUMBER === 'true';
export const recordListShowEmail = process.env.REACT_APP_RECORD_LIST_SHOW_EMAIL === 'true';
// please also edit CouponTransaction.scss file
export const recordListUserInfo = [
  {
    displayName: 'Name (preferred name)',
    fieldName: 'name',
    orderField: 'customerFirstName',
    linked: false,
    customerLink: true,
  },
  ...(
    recordListShowPhoneNumber
      ? [{
        displayName: "Mobile number",
        fieldName: "mobilePhoneNumber",
        linked: false,
      }]
      : []
  ),
  ...(
    recordListShowEmail
      ? [{
        displayName: "Email",
        fieldName: "email",
        linked: false,
      }]
      : []
  ),
  {
    displayName: 'Membership\r\nID',
    fieldName: 'membershipId',
    orderField: 'membershipId',
    linked: false,
  },
]

export const ACCOUNT_STATUS_TYPE = {
  ACTIVE: "ACTIVE",
  TEMPORARY_EARNING: "TEMPORARY_EARNING",
  TEMPORARY: "TEMPORARY",
  PROSPECT: "PROSPECT",
};

export const DISPLAY_ACCOUNT_STATUS_TYPE = {
  [ACCOUNT_STATUS_TYPE.ACTIVE]: "Activated",
  [ACCOUNT_STATUS_TYPE.TEMPORARY_EARNING]: "Temp (can earn)",
  [ACCOUNT_STATUS_TYPE.TEMPORARY]: "Temp (cannot earn)",
  [ACCOUNT_STATUS_TYPE.PROSPECT]: "Prospect",
};

export const PointSettingExpiryRule = {
  EXPIRE_AFTER_X_DAYS: "EXPIRE_AFTER_X_DAYS",
  NEVER_EXPIRE: "NEVER_EXPIRE",
  FIXED_DATE: "FIXED_DATE",
  FIXED_DATE_RANGE: "FIXED_DATE_RANGE",
};
export const RECORD_FILTER_REWARD_SCOPES = {
  ALL_ISSUED: "ALL_ISSUED",
  PARTIALLY_ISSUED: "PARTIALLY_ISSUED",
  NONE_ISSUED: "NONE_ISSUED"
}

export const MERCHANT_RECORD_TYPE = {
  REDEEMED_COUPON: "REDEEMED_COUPON",
  USE_CASH_DOLLAR: "USE_CASH_DOLLAR",
  ADJUST_REWARDS: "ADJUST_REWARDS",
  SELECT_STORE: "SELECT_STORE",
  APPROVE_EARNING_RULES: "APPROVE_EARNING_RULES",
}

export const MERCHANT_ADJUST_REWARDS_TYPE = {
  ADD_COUPON: "ADD_COUPON",
  REMOVE_COUPON: "REMOVE_COUPON",
  ADD_POINTS: "ADD_POINTS",
  REMOVE_POINTS: "REMOVE_POINTS",
  ADD_PROGRESSION_POINTS: "ADD_PROGRESSION_POINTS",
  REMOVE_PROGRESSION_POINTS: "REMOVE_PROGRESSION_POINTS",
  ADD_STAMPS: "ADD_STAMPS",
  REMOVE_STAMPS: "REMOVE_STAMPS",
}

export const DISPLAY_MERCHANT_RECORD_TYPE = {
  [MERCHANT_RECORD_TYPE.REDEEMED_COUPON]: "Redeem coupon",
  REDEEMED_TICKET: "Redeem ticket",
  [MERCHANT_RECORD_TYPE.USE_CASH_DOLLAR]: "Use cash dollar",
  [MERCHANT_RECORD_TYPE.SELECT_STORE]: "Select store",
  [MERCHANT_RECORD_TYPE.APPROVE_EARNING_RULES]: "Approve earning rules",

  [MERCHANT_ADJUST_REWARDS_TYPE.ADD_COUPON]: "Add coupon",
  [MERCHANT_ADJUST_REWARDS_TYPE.REMOVE_COUPON]: "Remove coupon",
  [MERCHANT_ADJUST_REWARDS_TYPE.ADD_POINTS]: "Add points",
  [MERCHANT_ADJUST_REWARDS_TYPE.REMOVE_POINTS]: "Remove points",
  [MERCHANT_ADJUST_REWARDS_TYPE.ADD_PROGRESSION_POINTS]: "Add progression points",
  [MERCHANT_ADJUST_REWARDS_TYPE.REMOVE_PROGRESSION_POINTS]: "Remove progression points",
  [MERCHANT_ADJUST_REWARDS_TYPE.ADD_STAMPS]: "Add stamps",
  [MERCHANT_ADJUST_REWARDS_TYPE.REMOVE_STAMPS]: "Remove stamps",
  ADD_TICKET: "Add ticket",
  REMOVE_TICKET: "Remove ticket",
}

